module.exports = __webpack_public_path__ + "static/media/KI.d813b860.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/KI.svg
// module id = 2185
// module chunks = 7